import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { setRequestLanguage } from '@/lib/api/client'
import { LangContext, persistLang, startingLang, type Lang, type LangState } from './i18n'

/**
 * Interface language. Interface strings live next to the components that
 * use them as `t(english, arabic)` pairs — the same shape as the design —
 * while data arrives already localized from the API.
 */
export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(startingLang)

  const setLang = useCallback((next: Lang) => {
    // Before the state change, so the refetch it causes asks in the new language.
    setRequestLanguage(next)
    persistLang(next)
    setLangState(next)
  }, [])

  const value = useMemo<LangState>(
    () => ({ lang, setLang, t: (en, ar) => (lang === 'ar' && ar ? ar : en) }),
    [lang, setLang],
  )

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>
}
